import { Injectable } from '@angular/core';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExternalApisService {

  //readonly rootURLNorris = 'https://api.icndb.com/jokes/random/1?client=4&clientVersion=0.1';
  readonly rootURLNorris = 'https://api.chucknorris.io/jokes/random';
  readonly rootURLNumber = 'http://numbersapi.com/';
  readonly rootURLVideos ='https://www.googleapis.com/';
 // readonly rootURLPhotos = 'https://mnbcorecrudapi.azurewebsites.net/api/';
  readonly rootURLPhotos = 'https://mnb-photos.azurewebsites.net/api/';
  constructor(private http: HttpClient) { }


  getNorrisJoke() {1
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURLNorris;
    var ret = this.http.get<any>(url);
    return ret;

  }

  getNumberTrivia(num: number) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURLNumber;
    var url2 = url + num + '/trivia'
    var ret = this.http.get(url2, { responseType: 'text' });
    var test = ret;
    return ret;
  }
getVideos(){
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

  var url = this.rootURLVideos + 'youtube/v3/playlistItems?playlistId=PLCRReD9CJChCJc7YyU8DSssz2StRmHgv_&key=AIzaSyDZtvUlwTwEfX8-ZePF1Dv-OxWlDUccz_Q&fields=items&part=snippet&maxResults=10&alt=json';
  var ret = this.http.get<any>(url);
  return ret;
}

getPhotosByGallery(id: any) {
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

  var url = this.rootURLPhotos;
  var url2 = url + 'Photos/GetFilesByDirectory2?folderName='+id;
  var ret = this.http.get(url2);
  var test = ret;
  return ret;
}

}
